/* eslint-disable */
export default {
  forward: 'Doorverbinden',
  reply: 'Beantwoorden',
  ignore: 'Negeren',
  toVoicemail: 'Naar voicemail',
  answer: 'Beantwoorden',
  answerAndEnd: 'Beantwoorden en beëindigen',
  answerAndHold: 'Beantwoorden en in de wacht zetten',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
